import classNames from 'classnames';
import createUseStyles from '../create/index.js';
import { j as jsxRuntimeExports } from '../jsx-runtime-KJzvSKZ_.js';

var LoaderMode = /*#__PURE__*/function (LoaderMode) {
  LoaderMode["FullScreen"] = "fullscreen";
  LoaderMode["Static"] = "static";
  LoaderMode["Cover"] = "cover";
  return LoaderMode;
}({});

var useStyles = createUseStyles({
  spinnerWrapper: {
    position: 'relative',
    display: 'inline-block',
    width: 32,
    height: 32,
    '&.fullscreen': {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1000
    },
    '&.static': {
      minHeight: 32,
      minWidth: 32
    },
    '&.cover': {
      minHeight: 32,
      minWidth: 32,
      position: 'absolute',
      top: '50%',
      left: '50%',
      zIndex: 1,
      transform: 'translate(-50%, -50%)'
    }
  },
  spinner: {
    animation: '$rotate 1s linear infinite',
    zIndex: 2,
    position: 'absolute',
    width: 32,
    height: 32,
    '& .path': {
      stroke: 'var(--accents-primary-base)',
      strokeLinecap: 'round',
      animation: '$dash 1.5s ease-in-out infinite'
    }
  },
  '@keyframes rotate': {
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  '@keyframes dash': {
    '0%': {
      strokeDasharray: '1, 150',
      strokeDashoffset: '0'
    },
    '50%': {
      strokeDasharray: '90, 150',
      strokeDashoffset: '-35'
    },
    '100%': {
      strokeDasharray: '90, 150',
      strokeDashoffset: '-124'
    }
  }
});

function Loader(_ref) {
  var _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? LoaderMode.Cover : _ref$mode;
  var styles = useStyles({
    mode: mode
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx("div", {
    className: classNames(styles.spinnerWrapper, mode),
    children: /*#__PURE__*/jsxRuntimeExports.jsx("svg", {
      className: styles.spinner,
      viewBox: "0 0 50 50",
      children: /*#__PURE__*/jsxRuntimeExports.jsx("circle", {
        className: "path",
        cx: "25",
        cy: "25",
        r: "20",
        fill: "none",
        strokeWidth: "5"
      })
    })
  });
}

export { LoaderMode, Loader as default };
//# sourceMappingURL=index.js.map
